// extracted by mini-css-extract-plugin
export default {"root":"UpdateCard_root__PlMT+","header":"UpdateCard_header__1A9G8","description":"UpdateCard_description__ZyCCU","fixes":"UpdateCard_fixes__DaOzr"};